/* eslint-disable */
import Api from 'lib/api';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import isEqual from 'lodash/isEqual';
import Data from 'containers/Data';
import {Switch, Route, Redirect} from 'react-router-dom';
import WLCNav from './components/WLCNav';
import ActionHours from './pages/ActionHours';
import Article from './pages/Article';
import Bonuses from './pages/Bonuses';
import Collection from './pages/Collection';
import CollectionsList from './pages/CollectionsList';
import CurrentWeek from './pages/CurrentWeek';
import Forum from './pages/Forum';
import CommunityGuidelines from './pages/CommunityGuidelines';
import Dashboard from './pages/Dashboard';
import GettingStarted from './pages/GettingStarted';
import RecipesList from 'routes/Products/components/RecipesList';
import SpecialReports from './pages/SpecialReports';
import Tools from './pages/Tools';
import VideoResource from '../../components/VideoResource';
import WeeksPage from './pages/WeeksPage';
import RecipesPage from './pages/RecipesPage';
import Video from '../../components/Video';
import {actions} from 'modules/user';
import ProductSidebar from 'components/ProductSidebar';
import MedicalDisclaimer from 'components/MedicalDisclaimer';
import GeneralContentContainer from 'containers/GeneralContentContainer';
import AbsoluteRedirect from 'components/AbsoluteRedirect';
import {faUtensils} from '@fortawesome/pro-regular-svg-icons/faUtensils';
import {faUsers} from '@fortawesome/pro-regular-svg-icons/faUsers';
import {faVideo} from '@fortawesome/pro-regular-svg-icons/faVideo';
import {faBook} from '@fortawesome/pro-regular-svg-icons/faBook';
import {faMap} from '@fortawesome/pro-regular-svg-icons/faMap';
import {faAddressCard} from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import styles from 'styles/index.scss';
import GeneralContentContainerApiComponents from '../../../../containers/GeneralContentContainerApiComponents';
import SearchPage from './pages/SearchPage';
const {removePadding, wlcContainer} = styles;
const WEEKS_LIST_SLUG = process.env.WEEKS_LIST_SLUG; //'wlc-18-weeks-list'; //the weeks list slug, needs to be updated depending on env
const ONBOARD_CONTENT_ID = process.env.ONBOARD_CONTENT_ID; //5; //onbaord content for this product
const ACTION_HOURS_ID = process.env.ACTION_HOURS_ID; //358; //all actions for this product

@connect(() => null, {
  refreshToken: actions.refreshToken,
  revokeDiscourseApiKey: actions.revokeDiscourseAPIKey,
  get: actions.getUserData,
  post: actions.postUserData
})
class WLC extends Component {
  constructor(props) {
    super(props);

    this.id = 1;
    this.slugsCache = {};
    this.dynamicComponents = {
      article: Article,
      bonuses: Bonuses,
      collection: Collection,
      collectionsList: CollectionsList,
      recipesList: RecipesList,
      specialReports: SpecialReports,
      tools: Tools,
      videoResource: VideoResource,
      video: Video
    };
    const thisPath = location.pathname.split('/');
    this.thisProductInPath = thisPath[2];

    this.state = {
      thisWeek: {id: null, Children: []},
      sortedWeeksList: [],
      // loading: true,
      loadingState: true,
      canShowOnboard: false,
      toursCompleted: {},
      navItems: [
        {name: 'Dashboard', typeOfComponent: 'Dashboard', slug: '', icon: faAddressCard},
        {name: 'Weekly Guide', typeOfComponent: null, slug: 'current-week', icon: faMap},
        {name: 'Recipes', typeOfComponent: 'RecipesGrid', slug: 'recipes', icon: faUtensils},
        {name: 'Forum', typeOfComponent: null, slug: 'community', icon: faUsers},
        {name: 'Action Hours', typeOfComponent: null, slug: 'action-hours', icon: faVideo},
        {name: 'Resources', typeOfComponent: null, slug: 'resources', icon: faBook}
      ], //used to show what nav items are present in top};
      gettingStartedCompleted: false
    };

    this.PREVENT_NAV_TO_GETTING_STARTED = window.PREVENT_NAV_TO_GETTING_STARTED;
    window.REVENT_NAV_TO_GETTING_STARTED = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !(
        isEqual(prevState.toursCompleted, this.state.toursCompleted) &&
        isEqual(prevState.gettingStartedCompleted, this.state.gettingStartedCompleted)
      )
    ) {
      const {gettingStartedCompleted, toursCompleted} = this.state;
      const userData = this.props.get(this.id);
      userData.then(data => {
        const newState = {
          ...data,
          ...{gettingStartedCompleted, toursCompleted}
        };

        this.props.post(this.id, newState);
      });
    }
  }

  componentDidMount() {
    this.getState();
    this.props.refreshToken();
  }
  getWLCContent() {
    const slug = 'wlc'; //for clarity
    const url = `/products/${slug}/content`;

    let {authToken} = JSON.parse(localStorage.getItem('user'));
    const token = this.props.authToken || authToken;
    //TODO pull this out when all content is self-succient ///Currently not being called, just here for reference ATM
    Api.get(url, token)
      .then(res => {
        //todo consolidate set state
        this.setState({contentItem: res.ContentItem});
        if (res.ContentItem) {
          const weeksListContentItem = res.ContentItem.Children.find(child => child.type === 'weeksList');
          const allWeeksList = res.ContentItem.Children.filter(child => child.type === 'weeksList')[0].Children;
          const sortedWeeksList = allWeeksList.reverse();
          const thisWeek = this.getCurrentWeek(allWeeksList);
          const allActionHours = res.ContentItem.Children.find(item => item.type === 'actionHoursList').Children;
          const actionHoursList = res.ContentItem.Children.find(item => item.type === 'actionHoursList');
          const allRecipes = [];
          const allWeekRecipesLists = [];
          //getting all the recipesLists in WLC..will remove once there is an API call
          allWeeksList.map(week => {
            const recipesList = week.Children.filter(child => child.type === 'recipesList')[0];
            allWeekRecipesLists.push(recipesList);
            if (recipesList) {
              recipesList.Children.map(recipe => allRecipes.push(recipe));
            }
          });

          //const thisWeek = this.getCurrentWeek(weeksList );
          let navItems = this.state.navItems;
          navItems[1].slug = thisWeek.slug;
          this.setState({
            actionHoursList,
            allActionHours,
            allRecipes,
            allWeekRecipesLists,
            contentItem: res.ContentItem,
            sortedWeeksList,
            thisWeek,
            // loading: false,
            navItems: navItems,
            weeksListContentItem
          });

          //for legacy to work
          this.weeksListContentItem = res.ContentItem.Children.find(child => child.type === 'weeksList');

          this.allWeeksList = res.ContentItem.Children.filter(child => child.type === 'weeksList')[0].Children;
          this.sortedWeeksList = this.allWeeksList.reverse();
          this.thisWeek = this.getCurrentWeek(this.sortedWeeksList);

          this.allResources = [];
          this.allRecipes = [];
          this.allWeekRecipesLists = [];
          this.allWeekResourcesLists = [];
          this.allActionHours = res.ContentItem.Children.find(item => item.type === 'actionHoursList').Children; //this.Children.actionHoursList ? this.Children.actionHoursList.Children : [];

          this.id = res.ContentItem.id; //props.id;
          this.onboardId = null;

          this.sortedWeeksList = this.allWeeksList.reverse(); //this.Children.weeksList.Children;
          //this.sortedWeeksList.reverse();
          //this.Children.weeksList.Children.map(week => {
          this.allWeeksList.map(week => {
            // const broadCastListsArray = week.Children.filter(child => child.type === 'broadcastsList');
            const recipesList = week.Children.filter(child => child.type === 'recipesList')[0];
            this.allWeekRecipesLists.push(recipesList);

            const thisWeeksResourcesList = week.Children.filter(child => child.type === 'resourcesList')[0];
            this.allWeekResourcesLists.push(thisWeeksResourcesList);

            //Set onboardId so we can query and navigate to it if not complete
            if (week.slug.includes('getting-started')) {
              this.onboardId = week.id;
              this.onboardSlug = week.slug;
            }

            // Make each resource availabe to initialize as route
            if (thisWeeksResourcesList) {
              thisWeeksResourcesList.Children.map(resource => {
                resource.thisWeeksResourcesList = thisWeeksResourcesList; //used to render resourcesList in child resource pages
                if (!this.slugsCache[resource.slug]) {
                  this.allResources.push(resource);
                  this.slugsCache[resource.slug] = true;
                }
              });
            }

            if (recipesList) {
              recipesList.Children.map(recipe => this.allRecipes.push(recipe));
            }
          });

          //this incorporates getWeeksList() functionality
          navItems = this.state.navItems;
          navItems[1].slug = thisWeek.slug;

          this.setState({
            sortedWeeksList: this.sortedWeeksList,
            // thisWeek: this.thisWeek,
            loading: false,
            navItems: navItems
          });
        }
      })
      .catch(e => {
        console.log('error loading WLC', e);
      });
  }

  handleMessageBus = () => {
    // when navigating between menu items remove or stop messagebus
    // otherwise polling will continue, messages will continue to come in
    if (window?.MessageBus) {
      delete window.MessageBus;
    }
  };

  handleNav = (name, typeOfComponent, slug) => {
    this.handleMessageBus();
    this.props.history.push(`/products/${this.thisProductInPath}/${slug}`);
    window.scrollTo(0, 0);
  };
  gettingStartedCheck = () => {
    if (!this.state.gettingStartedCompleted) {
      this.setState({gettingStartedCompleted: true});
      this.handleNav(null, null, 'getting-started');
    }
  };

  async getState() {
    const savedState = await this.props.get(this.id);
    this.setState({...savedState, loadingState: false}, this.gettingStartedCheck);
  }

  getCurrentWeek = weeksList => {
    return weeksList[0];
    /*
    const rightNow = Date.now();
    // go in order from most recent weeks, find current (should be the last)
    let index = weeksList.length - 1;
    while (rightNow < weeksList[index].data.startTime) {
      if (index <= 0) {
        return weeksList[0];
      }
      index -= 1;
    }
    return weeksList[index];
    */
  };
  //Legacy, just getting in for referenc ATM
  // Move to the onboard if not complete
  checkIfOnboardComplete = async () => {
    const {thisWeek} = this.state;
    const thisPath = location.pathname.split('/');
    const thisProductInPath = thisPath[2];
    const thisSlug = thisPath[3];
    let isHome;
    // let isOnboard;

    if (!thisSlug) {
      isHome = true;
    }

    const isOnboard =
      (!!thisPath[3] && thisPath[3].includes('getting-started')) ||
      (thisWeek.slug && thisWeek.slug.includes('getting-started')); //iow there is only one week

    //If not on onboard and we have an onboard id
    if (false || (isHome && !isOnboard && this.onboardId && !this.PREVENT_NAV_TO_GETTING_STARTED)) {
      // This gets seek on Week to prevent this check IF user just navigated from getting started week
      window.PREVENT_NAV_TO_GETTING_STARTED = null;
      const {authToken, userId} = JSON.parse(localStorage.getItem('user'));
      const url = `/users/${userId}/content/${this.onboardId}`;
      const response = await Api.get(url, authToken);
      const onboardState = response && response[0] && response[0].data;
      if (!response.length || (onboardState && !onboardState.complete && !onboardState.neverShowAgain)) {
        //If not complete, move to the onboard/ getting-started week:
        this.props.history.push(`/products/${this.thisProductInPath}/${this.onboardSlug}`);
      }
    } else {
      this.setState({canShowOnboard: true});
    }
  };

  getComponent = type => {
    const component = this.dynamicComponents[type];
    return component;
  };

  updateTourStatus = (tour, status) => {
    return this.setState({toursCompleted: {...this.state.toursCompleted, [tour]: status}});
  };

  render() {
    const {Children} = this;
    const path = location.pathname.split('/');
    const thisProductInPath = path[2];
    const contentItemSlug = path[3];
    // let productSlug = path[path.length - 2];

    // iow we are on recipe
    const renderWithoutContainer =
      contentItemSlug && (contentItemSlug.includes('recipe') || contentItemSlug.includes('article'));

    //const {actionHoursList = {id: null}, landing, welcome} = Children; //pulled weeksList out of here

    const weeksList = this.weeksListContentItem;

    const {
      actionHoursList,
      allRecipes,
      loading,
      canShowOnboard,
      sortedWeeksList,
      thisWeek,
      loadingState,
      toursCompleted,
      weeksListContentItem
    } = this.state;

    // if (loading) return null;

    //const EveryPageWeeksList = Data(WeeksList, `/content/${weeksList.id}/${thisProductInPath}`);

    const {navItems} = this.state;

    return (
      <div>
        <ProductSidebar navItems={navItems} handleNav={this.handleNav}>
          <div className="wlcContainer">
            <WLCNav
              allWeekResourcesLists={this.allWeekResourcesLists}
              allWeekRecipesLists={this.allWeekRecipesLists}
              sortedWeeksList={sortedWeeksList}
              thisWeek={thisWeek}
            />

            <Switch>
              {/* WLC doesn't have access to HOST/products from its router, so we use an abosolute redirect component which uses vanilla js to redirect */}
              <Route
                exact
                path={`/products/${thisProductInPath}/search`}
                render={() => {
                  let {authToken} = JSON.parse(localStorage.getItem('user'));
                  const token = this.props.authToken || authToken;
                  return <SearchPage authToken={token} />;
                }}
              />
              <Route
                exact
                path={`/products`}
                render={() => {
                  console.log('products route');
                  return <AbsoluteRedirect to={'/products/'} />;
                }}
              />
              {/* Onboarding week.  Need clean from legacy, todo */}
              <Route
                exact
                path={`/products/${thisProductInPath}/getting-started`}
                render={() => (
                  <GettingStarted
                    toursCompleted={toursCompleted}
                    toursLoaded={!loadingState}
                    updateTourStatus={this.updateTourStatus}
                  />
                )}
              />
              {/* all action hours page */}
              <Route
                exact
                path={`/products/${thisProductInPath}/action-hours`}
                component={props => {
                  return (
                    <GeneralContentContainer
                      overrideSlug={'action-hours'}
                      Component={ActionHours}
                      dataMassager={null} //used if data transformation is needed from the contentItem
                    />
                  );
                }}
              />
              {/* dashboard  **/}
              <Route
                exact
                path={`/products/${thisProductInPath}/`}
                render={() => (
                  <Dashboard
                    //all weeks for this product
                    weeksListSlug={WEEKS_LIST_SLUG}
                    //onbaord content for this product
                    onBoardContentId={ONBOARD_CONTENT_ID}
                    //all actions for this product
                    actionHoursId={ACTION_HOURS_ID}
                    {...this.state.contentItem}
                    //JoyRide stuff
                    toursCompleted={toursCompleted}
                    toursLoaded={!loadingState}
                    updateTourStatus={this.updateTourStatus}
                  />
                )}
              />
              {/* resources page */}
              <Route
                exact
                path={`/products/${thisProductInPath}/resources`}
                component={props => {
                  let {authToken} = JSON.parse(localStorage.getItem('user'));
                  const token = this.props.authToken || authToken;
                  return <SearchPage authToken={token} />;
                }}
                // component={props => {
                //   return (

                //     <GeneralContentContainer
                //       overrideSlug={WEEKS_LIST_SLUG}
                //       Component={ResourcesGrid}
                //       dataMassager={null} //used if data transformation is needed from the contentItem
                //       // overrideSlug={`recipe/${recipe.slug}`}
                //       componentProps={{customTitle: `WLC Resources`, isPageView: true}}
                //     />
                //   );
                // }}
              />
              {/* weeks page */}
              <Route
                exact
                path={`/products/${thisProductInPath}/weeks`}
                component={() => <WeeksPage product="wlc" slug={WEEKS_LIST_SLUG} />}
              />
              {/* current week, this puts the get weeks call outside of wlc index */}
              <Route
                exact
                path={`/products/${thisProductInPath}/current-week`}
                // render={() => <Redirect to={`/products/${thisProductInPath}/${this.thisWeek.slug}`} />}
                render={props => (
                  <CurrentWeek
                    toursCompleted={toursCompleted} //for Week only
                    toursLoaded={!loadingState} //for Week only
                    updateTourStatus={this.updateTourStatus} //for week only
                  />
                )}
              />
              {/* recipes page */}
              <Route
                exact
                path={`/products/${thisProductInPath}/recipes`}
                component={() => {
                  let {authToken} = JSON.parse(localStorage.getItem('user'));
                  const token = this.props.authToken || authToken;
                  //this is a dataMassager for WLC content item to return all recipes and then pass into GlobalSearch
                  const returnAllRecipesForGlobalSearch = contentItem => {
                    const allWeeksList = contentItem.Children.filter(child => child.type === 'weeksList')[0].Children;
                    const allRecipes = [];
                    const allWeekRecipesLists = [];
                    //getting all the recipesLists in WLC..will remove once there is an API call
                    allWeeksList.map(week => {
                      const recipesList = week.Children.filter(child => child.type === 'recipesList')[0];
                      allWeekRecipesLists.push(recipesList);
                      if (recipesList) {
                        recipesList.Children.map(recipe => allRecipes.push(recipe));
                      }
                    });

                    return {id: contentItem.id, Children: allRecipes};
                  };

                  return <RecipesPage authToken={token} />; //<GlobalSearchV2 types={['recipe']} authToken={token} />;
                }}
              />
              <Route
                exact
                path={`/products/${thisProductInPath}/community`}
                render={props => (
                  <Forum
                    {...props}
                    product="wlc"
                    toursCompleted={toursCompleted}
                    toursLoaded={!loadingState}
                    updateTourStatus={this.updateTourStatus}
                  />
                )}
              />
              <Route
                path={`/products/${thisProductInPath}/community/*`}
                render={props => (
                  <Forum
                    {...props}
                    {...{
                      product: 'wlc',
                      sortedWeeksList,
                      toursCompleted,
                      toursLoaded: !loadingState,
                      updateTourStatus: this.updateTourStatus
                    }}
                  />
                )}
              />

              {/* wildcard routes for week, recipe, actionhour, resource */}
              <Route
                key={'wildcard'}
                exact
                path={`*/:slug/`}
                component={props => {
                  console.log('wildcard being loaded', props);
                  return (
                    <GeneralContentContainerApiComponents
                      dataMassager={null} //used if data transformation is needed from the contentItem
                      Component={null}
                      componentProps={{
                        toursCompleted, //for Week only
                        toursLoaded: !loadingState, //for Week only
                        updateTourStatus: this.updateTourStatus //for week only
                      }}
                    />
                  );
                }}
              />
              <Route
                exact
                path={`/products/${thisProductInPath}/communityguidelines`}
                component={Data(CommunityGuidelines, `/content/wlc-community-guidelines/WLC`)}
              />
              {/* without gen container */}
              {/* <Route
                  exact
                  path={`//testWildSlug/:recipeslug`}
                  component={props => {
                    return (
                      <GeneralContentContainerApiComponents
                        dataMassager={null} //used if data transformation is needed from the contentItem
                        // overrideSlug={`recipe/${recipe.slug}`}
                        Component={Recipe}
                        componentProps={null}
                        type={'recipeslug'}
                      />
                    );
                  }}
                /> */}
              {/* legacy */}
              {/* {this.allActionHours && this.allActionHours.length
                  ? this.allActionHours.map(actionHour => {
                      return (
                        <Route
                          key={actionHour.title}
                          exact
                          path={`/*${actionHour.slug}/`}
                          component={Data(ActionHour, `/content/${actionHour.id}/${thisProductInPath}`, {
                            isActionHour: true
                          })}
                        />
                      );
                    })
                  : null} */}
              {/* TODO is this used any more? */}
              {/* {this.allWeekRecipesLists && this.allWeekRecipesLists.length
                  ? this.allWeekRecipesLists.map(recipesList =>
                      recipesList ? (
                        <Route
                          key={recipesList.title}
                          exact
                          path={`//${recipesList.slug}/`}
                          component={Data(RecipesGrid, `/content/${recipesList.id}/${thisProductInPath}`, {
                            customTitle: recipesList.title,
                            updateTourStatus: this.updateTourStatus
                          })}
                        />
                      ) : null
                    )
                  : null} */}
              {/* Legacy resources */}
              {/* {this.allResources && this.allResources.length
                  ? this.allResources.map(resource => (
                      <Route
                        key={resource.title}
                        exact
                        path={`//${resource.slug}/`}
                        component={Data(
                          this.getComponent(resource.type),
                          `/content/${resource.id}/${thisProductInPath}`,
                          {
                            thisWeeksResourcesList: resource.thisWeeksResourcesList
                          }
                        )}
                      />
                    ))
                  : null} */}
              {/* circle back todo */}
              {/* <Route
                  exact
                  path={`//resources/:slug}/`}
                  component={props => {
                    return (
                      <GeneralContentContainerApiComponents
                        dataMassager={null} //used if data transformation is needed from the contentItem
                        // overrideSlug={`recipe/${recipe.slug}`}
                        Component={null}
                        componentProps={null}
                      />
                    );
                  }}
                /> */}
              {/* legacy resources */}
              {/* {this.allWeekRecipesLists && this.allWeekResourcesLists.length
                  ? this.allWeekResourcesLists.map(resourcesList => (
                      <Route
                        key={resourcesList.title}
                        exact
                        path={`//${resourcesList.slug}/`}
                        component={Data(ResourcesListTwo, `/content/${resourcesList.id}/${thisProductInPath}`, {
                          customTitle: `This week's resources`,
                          isPageView: true,
                          colSizes: {xs: 6, sm: 4, md: 3}
                        })}
                      />
                    ))
                  : null} */}
              {/* recipe original */}
              {/* {this.allRecipes && this.allRecipes.length
                  ? this.allRecipes.map(recipe => (
                      <Route
                        key={recipe.title}
                        exact
                        path={`//${recipe.slug}/`}
                    //     component={Data(Recipe, `/content/${recipe.id}/${thisProductInPath}`)}
                    //   />
                    // ))
                  // : null} */}
              {/* this works once data is loaded but not for direct URL */}
              {/* {this.allRecipes && this.allRecipes.length ? (
                  <Route
                    exact
                    path={`/products/${thisProductInPath}/recipes`}
                    component={() => (
                      <GlobalSearch
                        product={{id: 1, Children: this.allRecipes}}
                        showTypeArray={false}
                        typeArray={[{name: 'recipe', active: true}]}
                      />
                    )}
                  />
                ) : null} */}
              {/* Legacy ALL Recipes
                <Route
                  exact
                  path={`/products/${thisProductInPath}/recipes`}
                  component={Data(RecipesGrid, `/content/${weeksList.id}/${thisProductInPath}`, {
                    customTitle: 'All Your Resources',
                    updateTourStatus: this.updateTourStatus
                  })}
                /> */}
              {/* legacy weeks */}
              {/* {this.sortedWeeksList ? (
                  <Route
                    exact
                    path={`/products/${thisProductInPath}/weeks`}
                    component={() => <Weeks sortedWeeksList={sortedWeeksList} thisWeek={thisWeek} />}
                  />
                ) : null} */}
              <Redirect from={`/products/${thisProductInPath}/*`} to={`/products/${thisProductInPath}/`} />
            </Switch>
          </div>
          <MedicalDisclaimer />
        </ProductSidebar>
      </div>
    );
  }
}

WLC.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape({})
};

WLC.defaultProps = {
  data: {}
};

WLC.displayname = 'WLC';

export default withRouter(WLC);
